<template>
  <div class="product-header">
    <div class="product-preview">
      <div class="shop-breadcrumb">
        <router-link class="breadcrumb--link" :to="getRouteToHome()">Home</router-link>
      </div>
    </div>
  </div>
  <div class="loading">
    <p>
      <span class="site-loading">Loading ...</span>
    </p>
  </div>
</template>

<script>
import {getRouteToHome} from "~/_router/routeUtils";

export default {
  name: "LoadingComponent",
  setup(){


    return {
      getRouteToHome,
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~/assets/scss/settings/_config.scss" as *;
.product-header {
  display: flex;
  flex-direction: row;
  padding-bottom: 60px;
  position: relative;

  .product-preview {
    width: 65%;
    position: relative;

    @media (max-width: 940px) {
      width: 50%;
    }
  }

  @media (max-width: 740px) {
    flex-direction: column;

    .product-preview {
      width: 100%;
    }
  }
}

.loading {
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .site-loading {
    display: block;
    font-size: 72px;
    line-height: 74px;
    font-weight: 700;
    margin-bottom: 24px;
  }
}
</style>
